import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import CarouselCard from '../CarouselCard/CarouselCard';

function VeloTaxesCard() {
  const { businessEntityUuid } = useBusinessEntity();
  const href = `/guide/company/${businessEntityUuid}?topic=questions-about-taxes`;

  return (
    <CarouselCard
      imageSrc="/s2/raster/woman-desk-papers-carousel.png"
      imageAltId="dashboard.carousel.card.veloTaxes.imageAlt"
      titleId="dashboard.carousel.card.veloTaxes.title"
      subtitleId="dashboard.carousel.card.veloTaxes.subTitle"
      href={href}
      elementName="carousel_velo_taxes_link"
    />
  );
}

export default VeloTaxesCard;
